// extracted by mini-css-extract-plugin
module.exports = {"loader":"UploadSpinner_loader__381aA","spin":"UploadSpinner_spin__lxFe0"};